//import Swiper JS
import Swiper, { FreeMode, Navigation } from 'swiper';

Swiper.use([FreeMode, Navigation]);

document.addEventListener("DOMContentLoaded", function() {
    let swiperJobs = new Swiper(".jobsSwiper", {
        slidesPerView: 2.3,
        spaceBetween: 10,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-job-next",
            prevEl: ".swiper-job-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3.5
            },
            992: {
                slidesPerView: 4.5
            },
            1200: {
                slidesPerView: 5.5
            },
            1500: {
                slidesPerView: 7
            },
            2000: {
                slidesPerView: 7
            }
        },

    });
});